(function ($) {

    var spinnerName = 'spinner';
    var template =  "<div class=\"spinner\">\n" +
                    "  <div class=\"bounce1\"></div>\n" +
                    "  <div class=\"bounce2\"></div>\n" +
                    "  <div class=\"bounce3\"></div>\n" +
                    "</div>";

    $.fn.showSpinner = function () {
        var $spinner = $(template);
        this.data(spinnerName, $spinner);
        this.prepend($spinner)
    };

    $.fn.hideSpinner = function () {
        var $spinner = this.data(spinnerName);
        if ($spinner) {
            $spinner.remove();
        }
    };

}(jQuery));